/**
 * @generated SignedSource<<a1e0f5056ee371d7d9138f030dd754ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassExitSlipsFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  includeCanceled?: boolean | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type IndividualStudentReportStatsQuery$variables = {
  classExitSlipsFilter?: ClassExitSlipsFilterInput | null | undefined;
  from: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  to: any;
  userId: string;
};
export type IndividualStudentReportStatsQuery$data = {
  readonly classExitSlips: ReadonlyArray<{
    readonly curriculumLesson: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly number: string | null | undefined;
      readonly target: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly dueOn: any;
    readonly id: string;
    readonly learnosityExitSlipSessions: ReadonlyArray<{
      readonly activityId: string | null | undefined;
      readonly isComplete: boolean;
      readonly items: ReadonlyArray<{
        readonly attempted: boolean;
        readonly id: string;
        readonly itemReference: string | null | undefined;
        readonly maxScore: number;
        readonly questionNumber: number | null | undefined;
        readonly score: number | null | undefined;
      } | null | undefined> | null | undefined;
      readonly publicUserId: string | null | undefined;
      readonly score: number;
      readonly sessionCompletedOn: any;
      readonly sessionId: any;
      readonly sessionLength: number;
    } | null | undefined> | null | undefined;
  }>;
  readonly individualReportDailyActivity: ReadonlyArray<{
    readonly dailyActivitySkills: ReadonlyArray<{
      readonly code: string;
      readonly exampleVideoTime: number;
      readonly isTargetSkill: boolean;
      readonly name: string;
      readonly practiceProblemTime: number;
      readonly skillAssessments: ReadonlyArray<{
        readonly attemptNumber: number;
        readonly score: number;
        readonly sessionId: any;
      }>;
      readonly skillChallengesTime: number;
      readonly skillId: number;
      readonly skillInferredSkills: ReadonlyArray<{
        readonly code: string;
        readonly isTargetSkill: boolean;
        readonly name: string;
      }>;
    }>;
    readonly day: any;
  }>;
  readonly individualReportPerformanceStats: {
    readonly demonstratedSkillsInferred: number;
    readonly demonstratedSkillsPassed: number;
    readonly logins: number;
    readonly platformTime: number;
    readonly skillsWorkedOn: number;
  };
  readonly siteSchoolYears: ReadonlyArray<{
    readonly id: string;
    readonly startOn: any;
  }>;
};
export type IndividualStudentReportStatsQuery = {
  response: IndividualStudentReportStatsQuery$data;
  variables: IndividualStudentReportStatsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classExitSlipsFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "siteIds",
          "variableName": "siteIds"
        }
      ],
      "kind": "ObjectValue",
      "name": "filterInput"
    }
  ],
  "concreteType": "SiteSchoolYearNode",
  "kind": "LinkedField",
  "name": "siteSchoolYears",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startOn",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "fromDate",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "toDate",
    "variableName": "to"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v8 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "IndividualReportPerformanceStats",
  "kind": "LinkedField",
  "name": "individualReportPerformanceStats",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logins",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillsWorkedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "demonstratedSkillsPassed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "demonstratedSkillsInferred",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platformTime",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTargetSkill",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "IndividualReportDailyActivity",
  "kind": "LinkedField",
  "name": "individualReportDailyActivity",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IndividualReportDailyActivitySkill",
      "kind": "LinkedField",
      "name": "dailyActivitySkills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IndividualReportDailyActivitySkillInferred",
          "kind": "LinkedField",
          "name": "skillInferredSkills",
          "plural": true,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skillId",
          "storageKey": null
        },
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "practiceProblemTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "exampleVideoTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skillChallengesTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IndividualReportDailyActivitySkillAssessment",
          "kind": "LinkedField",
          "name": "skillAssessments",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attemptNumber",
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "classExitSlipsFilter"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueOn",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v18 = [
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "userIds.0",
            "variableName": "userId"
          }
        ],
        "kind": "ListValue",
        "name": "userIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "learnosityExitSlipSessionsFilter"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activityId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionLength",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionCompletedOn",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "LearnosityExitSlipSessionResponseNode",
  "kind": "LinkedField",
  "name": "items",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxScore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attempted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemReference",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportStatsQuery",
    "selections": [
      (v6/*: any*/),
      (v8/*: any*/),
      (v14/*: any*/),
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurriculumLessonNode",
            "kind": "LinkedField",
            "name": "curriculumLesson",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v17/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetNode",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "LearnosityExitSlipSessionNode",
            "kind": "LinkedField",
            "name": "learnosityExitSlipSessions",
            "plural": true,
            "selections": [
              (v19/*: any*/),
              (v13/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v12/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "IndividualStudentReportStatsQuery",
    "selections": [
      (v6/*: any*/),
      (v8/*: any*/),
      (v14/*: any*/),
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurriculumLessonNode",
            "kind": "LinkedField",
            "name": "curriculumLesson",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v17/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetNode",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "LearnosityExitSlipSessionNode",
            "kind": "LinkedField",
            "name": "learnosityExitSlipSessions",
            "plural": true,
            "selections": [
              (v19/*: any*/),
              (v13/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v12/*: any*/),
              (v24/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "837830aa22f5af5f90914cc1280ffd8d",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportStatsQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportStatsQuery(\n  $userId: ID!\n  $from: DateTime!\n  $to: DateTime!\n  $siteIds: [ID!]\n  $classExitSlipsFilter: ClassExitSlipsFilterInput\n) {\n  siteSchoolYears(filterInput: {siteIds: $siteIds}) {\n    id\n    startOn\n  }\n  individualReportPerformanceStats(userId: $userId, fromDate: $from, toDate: $to) {\n    logins\n    skillsWorkedOn\n    demonstratedSkillsPassed\n    demonstratedSkillsInferred\n    platformTime\n  }\n  individualReportDailyActivity(fromDate: $from, toDate: $to, userId: $userId) {\n    day\n    dailyActivitySkills {\n      skillInferredSkills {\n        isTargetSkill\n        name\n        code\n      }\n      skillId\n      isTargetSkill\n      name\n      code\n      practiceProblemTime\n      exampleVideoTime\n      skillChallengesTime\n      skillAssessments {\n        score\n        attemptNumber\n        sessionId\n      }\n    }\n  }\n  classExitSlips(filter: $classExitSlipsFilter) {\n    id\n    dueOn\n    curriculumLesson {\n      id\n      number\n      name\n      target {\n        name\n        id\n      }\n    }\n    learnosityExitSlipSessions(learnosityExitSlipSessionsFilter: {userIds: [$userId]}) {\n      activityId\n      sessionId\n      publicUserId\n      sessionLength\n      sessionCompletedOn\n      isComplete\n      score\n      items {\n        id\n        score\n        maxScore\n        questionNumber\n        attempted\n        itemReference\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a97ae4b05d41deada9cf4d77a626bdd";

export default node;
